<template>
  <div>
    <div class="d-flex align-center justify-space-between">
      <Title title="Procedimentos" />
      <FilterButton @click.native="updateFilter()" />
    </div>
    <FilterOptions v-if="filter" class="mt-8 mb-5" filter="procedimento" />
  </div>
</template>

<script>
import Title from "@/components/atoms/title";
import FilterButton from "@/components/molecules/filter-button";
import FilterOptions from "@/components/other/filter-component";

export default {
  components: { Title, FilterButton, FilterOptions },
  data() {
    return {
      filter: false
    };
  },
  methods: {
    updateFilter() {
      this.$store.dispatch("resetFilters", { filter: "procedimento" });
      this.filter = !this.filter;
      this.$emit("filterChange", this.filter);
    }
  }
};
</script>